import { Button } from '@bm-js/atlascloud-ui'
import Input from './Input'
import { ChangeEvent } from '@bm-js/atlascloud-shared'

type Props = {
  formData: {
    email: string
    fullName: string
  }
  handleChange: (e: ChangeEvent) => void
  submit: (e: React.FormEvent<HTMLFormElement>) => void
  loading: boolean
  errors: {
    email?: string
    fullName?: string
  }
}

const GetStartedEmail = ({
  formData,
  handleChange,
  submit,
  loading,
  errors,
}: Props) => {
  return (
    <div>
      <form onSubmit={submit} className='flex flex-col'>
        <Input
          disabled={loading}
          autoFocus
          label='Ange din mailadress'
          type='email'
          value={formData.email}
          error={errors.email}
          onChange={handleChange}
          name='email'
          required
          placeholder='mail@exempel.com'
        />
        <Input
          disabled={loading}
          placeholder='Förnamn Efternamn'
          label='...och ditt namn'
          type='text'
          value={formData.fullName}
          error={errors.fullName}
          onChange={handleChange}
          name='fullName'
          required
        />
        <Button className='self-end' disabled={loading} type='submit'>
          Gå vidare
        </Button>
      </form>
    </div>
  )
}

export default GetStartedEmail
